


export const DEFAULT_LANG_VALUE = 'en';

// Throttle times
export const EDITOR_UPDATE_THROTTLE_WAIT_TIME = 200;
export const EDITOR_UPDATE_WATCH_THROTTLE_WAIT_TIME = EDITOR_UPDATE_THROTTLE_WAIT_TIME - 80;

// Image size constants
export const IMAGE_MIN_SIZE = 20;
export const IMAGE_MAX_SIZE = 100000;
export const IMAGE_THROTTLE_WAIT_TIME = 16;

// Table grid sizes
export const TABLE_INIT_GRID_SIZE = 6;
export const TABLE_MAX_GRID_SIZE = 10;
export const TABLE_DEFAULT_SELECTED_GRID_SIZE = 2;

// Default color list
export const COLORS_LIST = [
  '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3',
  '#03a9f4', '#00bcd4', '#009688', '#4caf50', '#8bc34a', '#cddc39',
  '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#000000', '#333333',
  '#666666', '#999999', '#CCCCCC', '#D5D5D4', '#E8E8E8', '#EEEEEE'
];

// Font family
export const DEFAULT_FONT_FAMILY_VALUE = 'inherit';

export const DEFAULT_FONT_FAMILY_LIST = [
  { title: 'Archivo', value: DEFAULT_FONT_FAMILY_VALUE, divider: true, default: true },
  { title: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { title: 'Georgia', value: 'Georgia, serif' },
  { title: 'Times New Roman', value: '"Times New Roman", Times, serif' },
  { title: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
  { title: 'Courier New', value: '"Courier New", Courier, monospace', divider: true },
  { title: 'Monaco', value: 'Monaco, Menlo, Consolas, monospace' },
  { title: 'Monospace', value: 'monospace' }
];

// Markdown theme
export const DEFAULT_MARKDOWN_THEME_VALUE = 'default';
export const DEFAULT_MARKDOWN_THEME_LIST = [
  { title: 'editor.default', value: DEFAULT_MARKDOWN_THEME_VALUE, default: true }
];

// Font size
export const DEFAULT_FONT_SIZE_LIST = [8, 10, 12, 14, 16, 18, 20, 24, 30, 36, 48, 60, 72];
export const DEFAULT_FONT_SIZE_VALUE = 'default';

// Font weight
export const DEFAULT_FONT_WEIGHT_VALUE = 'default';
export const DEFAULT_FONT_WEIGHT_LIST = [100, 200, 300, 400, 500, 600, 700, 800];

// Letter spacing
export const DEFAULT_LETTER_SPACING_VALUE = 'default';

// Image and video sizes
export const IMAGE_SIZE = {
  'size-small': 200,
  'size-medium': 500,
  'size-large': '100%',
};

export const VIDEO_SIZE = {
  'size-small': 480,
  'size-medium': 640,
  'size-large': '100%',
};

// Bubble menu node actions
export const NODE_TYPE_MENU = {
  image: [
    'float-left', 'float-none', 'float-right', 'divider',
    'image-size-small', 'image-size-medium', 'image-size-large',
    'divider', 'textAlign', 'divider', 'image', 'image-aspect-ratio', 'remove'
  ],
  text: ['bold', 'italic', 'underline', 'strike', 'divider', 'color', 'highlight', 'textAlign', 'divider', 'link'],
  link: [
    'bold', 'italic', 'underline', 'strike', 'divider', 'color', 'highlight',
    'textAlign', 'divider', 'link', 'unlink', 'link-open'
  ],
  video: ['video-size-small', 'video-size-medium', 'video-size-large', 'divider', 'video', 'remove'],
  table: [
    'table-add-column-before', 'table-add-column-after', 'table-delete-column', 'divider',
    'table-add-row-before', 'table-add-row-after', 'table-delete-row', 'divider',
    'table-merge-or-split-cells', 'divider', 'table-delete-table', 'divider'
  ],
};
